<template>
	<section class="member-account">
		<el-row :gutter="16">
			<el-col :md="8" :sm="12" :xs="24">
				<el-card shadow="never">
					<div class="stat-title">现金账户</div>
					<div class="stat-value">
						￥{{ (account.balance || 0).toLocaleString() }}
					</div>
					<el-button type="primary" size="mini">
						去充值
					</el-button>
				</el-card>
			</el-col>
			<el-col :md="8" :sm="12" :xs="24">
				<el-card shadow="never">
					<div class="stat-title">授信额度</div>
					<div class="stat-value">
						￥{{ (account.credit || 0).toLocaleString() }}
					</div>
					<div class="stat-hint">
						可提交审批延长还款期
					</div>
				</el-card>
			</el-col>
			<el-col :md="8" :sm="12" :xs="24">
				<el-card shadow="never">
					<div class="stat-title">积分</div>
					<div class="stat-value">
						{{ account.points || 0 }}
					</div>
					<el-button type="text" size="mini">
						积分规则
					</el-button>
				</el-card>
			</el-col>
		</el-row>

		<el-card shadow="never" style="margin-top: 24px">
			<div slot="header">
				账户流水
			</div>
			<el-table :data="journals" size="small">
				<el-table-column prop="time" label="时间" width="160" />
				<el-table-column prop="type" label="类型" width="120" />
				<el-table-column prop="amount" label="金额" width="120" />
				<el-table-column prop="channel" label="渠道" width="150" />
				<el-table-column prop="remark" label="备注" min-width="200" />
			</el-table>
		</el-card>
	</section>
</template>

<script>
export default {
	name: 'MemberAccount',
	props: {
		account: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		journals() {
			return this.account.journals || []
		}
	}
}
</script>

<style lang="scss" scoped>
.stat-title {
	font-size: 13px;
	color: #909399;
	margin-bottom: 6px;
}

.stat-value {
	font-size: 28px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 12px;
}

.stat-hint {
	font-size: 12px;
	color: #909399;
}
</style>

